import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VisitorStats = () => {
  const [summary, setSummary] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const WEBSITE_CODE = "mr08";

  const fetchData = async () => {
    setLoading(true);
    try {
      // ambil summary + detail sekaligus
      const [summaryRes, detailRes] = await Promise.all([
        axios.get(`${API_BASE}/api/visitor/stats`),
        axios.get(`${API_BASE}/api/visitor/stats`, {
          params: {
            website_code: WEBSITE_CODE,
            page,
          },
        }),
      ]);

      // cari Merah Putih 08 dari summary
      const merahPutih = summaryRes.data.data.find((item: any) => item.code === WEBSITE_CODE);

      setSummary(merahPutih || null);

      setData(detailRes.data.data);
      setMeta(detailRes.data.pagination);
    } catch (err) {
      console.error("Gagal ambil statistik visitor", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  return (
    <div className="mt-6 space-y-6">
      {/* ================= CARD ================= */}
      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : (
        summary && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white rounded-xl shadow border p-5 hover:shadow-lg transition">
              <h3 className="text-lg font-semibold text-primary">{summary.name}</h3>
              <p className="mt-2 text-3xl font-bold text-gray-800">{summary.total || "-"}</p>
              <p className="text-sm text-gray-500">Total Pengunjung</p>
            </div>
          </div>
        )
      )}

      {/* ================= TABLE ================= */}
      <div className="bg-white rounded-xl shadow border overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-primary text-white">
            <tr>
              <th className="p-3 text-left">No</th>
              <th className="p-3 text-left">Tanggal</th>
              <th className="p-3 text-left">Jumlah Pengunjung</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={3} className="p-4 text-center text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={item.date} className="border-t hover:bg-orange-50 transition">
                  <td className="p-3">{(meta.current_page - 1) * meta.per_page + index + 1}</td>
                  <td className="p-3">{new Date(item.date).toLocaleDateString("id-ID")}</td>
                  <td className="p-3 font-semibold text-primary">{item.total}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ================= PAGINATION ================= */}
      {meta && meta.last_page > 1 && (
        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600">
            Page {meta.current_page} dari {meta.last_page} | Total {meta.total}
          </span>

          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Prev
            </button>

            <button disabled={page === meta.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisitorStats;
